import { LogMessage } from '@openticket/lib-shop';

export default function isOpenTicketLogMessage(e: unknown): e is LogMessage {
    return (
        !!e &&
        Object.prototype.hasOwnProperty.call(e, '_isOpenTicketLogMessage')
    );
}
